import { HiChevronDoubleRight } from "react-icons/hi"; 
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from '../../hx/useTranslation';
import '../../../styles/main.css';
import CxState from '../../cx/CxState';
import CxToolbar from '../../cx/CxToolbar';
import CxSnackbar from '../../cx/CxSnackbar';
import CxFile from '../../cx/CxFile';
import CxSearcher from '../../cx/CxSearcher';
import CxIconButtonNew from '../../cx/CxIconButtonNew';
import CxStatic from '../../cx/CxStatic';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import * as FxFile from '../../fx/FxFile';
//import * as FxDat from '../../fx/FxDat';
import { StorePurDocOcr } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';
import { StoreLongTask, clearStore } from "../../gx/GxStore";
import { useNav } from '../../hx/useNav';


const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'flex-start',
    gap: 'var(--ibs_container_gap)',
    margin: 'var(--ibs_container_margin)',
  },
  button_frame: {
    margin: '20px 0 0 0',
    display: 'flex',
    flexFlow: 'row wrap',
    alignItems: 'flex-start',
    gap: '12px',
    width: '100%',
  },
}));

const MxPurDocOcrOption = (props) => {
  const [{ trans }] = useTranslation();
  const [{ navTo }] = useNav();
  const classes = useStyles(props);

  const rf_txSupplier = React.useRef(null);
  const rf_create_pss = React.useRef(null);
  const rf_update_pss = React.useRef(null);
  const rf_price_inc_tax = React.useRef(null);
  const rf_file = React.useRef(null);
  
  const r_snack_error = React.useRef(null);

  const [storeLongTask, setStoreLongTask] = useSessionStorage('StoreLongTask', StoreLongTask);

  // eslint-disable-next-line
  const [storePurDocOcr, setStorePurDocOcr] = useSessionStorage('StorePurDocOcr', StorePurDocOcr);

  React.useEffect(() => {
    clearStore('StoreLongTask', storeLongTask);
    formLoad();
    // eslint-disable-next-line
  }, []);

  const formLoad = async () => {
  }

  const goNext = (op) => {
    try {
      if (rf_txSupplier.current.isEmpty()) {
        r_snack_error.current.setVal(trans('field.required') + ': ' + trans('field.supplier'));
        r_snack_error.current.setOpen(true);
        return;
      }
      if (rf_file.current.isEmpty()) {
        r_snack_error.current.setVal(trans('field.required') + `: ${trans('field.invoice')} - PDF`);
        r_snack_error.current.setOpen(true);
        return;
      }

      let file = rf_file.current.getFile();
      Promise.all([FxFile.getBase64FromFile(file)]).then((result) => {
        let strBase64 = result[0].replace('data:application/pdf;base64,', '');
        
        // pasamos a la pag de importación
        storeLongTask._url = 'pur/doclist/i/ocr/import';
        storeLongTask._canCancel = false;
        storeLongTask._record = { 
          txTaskName: "import_invoice", 
          inSupplier: rf_txSupplier.current.getKey(), 
          txSupplier: rf_txSupplier.current.getVal(), 
          strBase64: strBase64,
          boUnPricesIncTaxes: rf_price_inc_tax.current.getVal(),
          boCreatePss: rf_create_pss.current.getVal(),
          boUpdatePss: rf_update_pss.current.getVal(),
        };
        Promise.all([setStoreLongTask(storeLongTask)]).then((result) => {
          navTo('pur-doc-ocr-option-tsk');
        });
      });

    } catch (error) {
      FxLog.errorx("MxPurDocOcrOption.doTask", error);
    }
  }

  return (
    <div>
      <CxToolbar 
        moduleName={`PDF->DOC: ${trans('field.options')}`} 
        addToolbarButtons={
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <CxIconButtonNew icon={<HiChevronDoubleRight fontSize={23} />} classType="ibs_iconbutton_toolbar" onClick={goNext} tooltip={trans('field.next')} />
          </div>
        }
      />

      <div className={classes.container}>

        <CxStatic label={trans('msg.ai_results_may_contain_errors')} border='none' fontcolor='var(--ibs_color_red)' fontsize='12px' padding='2px 0px 2px 0px' />

        <CxSearcher xref={rf_txSupplier} label={trans('field.supplier')}
          dbfield="n_supplier.txSupplier" dbfieldkey={`n_ps.inSupplier`}
          url="suppliers"
          col_id="inSupplier"
          col_tx="txSupplier"
          tooltip={`${trans('field.supplier')}`}
          columns={[
            { id: "0", Header: "ID", accessor: "inSupplier", show: false },
            { id: "1", Header: trans('field.supplier'), accessor: row => rf_txSupplier.current.getTable().highlightText(row["txSupplier"]), width: '100%' },
          ]}
          required
        />

        <CxFile xref={rf_file} 
          label={`${trans('field.invoice')} - PDF`}
          fileTypes={['pdf']}
          required
        />

        <CxState mode='checkbox' xref={rf_create_pss} 
          label={trans('field.create_x', 'field.pss')} 
        />
        <CxState mode='checkbox' xref={rf_update_pss} 
          label={trans('field.update_x', 'field.files')} 
        />
        <CxState mode='checkbox' xref={rf_price_inc_tax} 
          label={trans('field.unit_prices_inc_taxes')} 
        />

      </div>

      <CxSnackbar xref={r_snack_error} severity="error" />

    </div>
  );

}

export default MxPurDocOcrOption;
